<template>
  <div>
    <DesktopSidebar :isForceMinimized="isForceMinimized" />
    <MobileSidebar />
  </div>
</template>

<script>
import DesktopSidebar from "./desktop-sidebar/DesktopSidebar.vue";
import MobileSidebar from "./mobile-sidebar/MobileSidebar.vue";
import { getUserInfo, getMenu } from "@/services";
import { computed, onMounted, provide, ref, toRefs } from "vue";
import { generateError } from "@/shared/utils";

export default {
  components: {
    DesktopSidebar,
    MobileSidebar,
  },
  props: {
    isForceMinimized: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // generate props data
    const { isForceMinimized } = toRefs(props);

    const userInfoLoading = ref(false);
    const menuLoading = ref(false);
    const getUserInfoData = async () => {
      try {
        userInfoLoading.value = true;
        await getUserInfo();
      } catch (error) {
        generateError(error);
      } finally {
        userInfoLoading.value = false;
      }
    };
    const getMenuData = async () => {
      try {
        menuLoading.value = true;
        await getMenu();
      } catch (error) {
        generateError(error);
      } finally {
        menuLoading.value = false;
      }
    };
    onMounted(() => Promise.all([getUserInfoData(), getMenuData()]));

    // handle provide data
    provide(
      "USER_INFO_LOADING",
      computed(() => userInfoLoading.value)
    );
    provide(
      "MENU_LOADING",
      computed(() => menuLoading.value)
    );

    // return data to be used in template
    return { isForceMinimized };
  },
};
</script>
